import {
  Analytics,
  Control,
  Functionality,
  Grouping,
} from '@yleisradio/areena-types';
import { Device, UtmParameters } from '../appTypings';
import { HbbTVDevice } from '../deviceTypes';
import { LoggedInUser, Mode, tizenMode } from '../../common/types';

const getDeviceVendor = (device: Device | undefined) => {
  return device?.vendor ? device?.vendor : '';
};

const getDeviceFamily = (device: Device | undefined) => {
  return device?.family || '';
};

export const getVrsDevice = (device: Device | undefined) => {
  const vendor = getDeviceVendor(device);

  if (device instanceof HbbTVDevice) {
    return `smart tv:${vendor} hbbtv`;
  }

  const family = getDeviceFamily(device);

  return `smart tv:${vendor} ${family}`;
};

export const findControlAnalyticsByFunctionality = (
  functionality: Functionality,
  groupings: Grouping[] | undefined
): Analytics | undefined => {
  if (groupings) {
    const predicate = (control: Control) =>
      control.functionality?.id === functionality.id;

    return groupings
      .find(grouping => grouping?.controls.find(predicate))
      ?.controls.find(predicate)?.analytics;
  }
};

export const getPreviewUtmParameters = (
  mode: Mode,
  id: string,
  isPlayerUri: boolean
): string => {
  const uriPostfix = isPlayerUri ? 'startover' : 'preview';
  const utmParameters = [
    `utm_source=${mode === tizenMode ? 'samsung' : mode}`,
    `utm_medium=external-tv`,
    `utm_campaign=${encodeURIComponent(id)}`,
    `utm_content=${encodeURIComponent(id)}-${uriPostfix}`,
  ];
  return utmParameters.join('&');
};

export const analyticsPageNames = {
  profile: 'profile_select',
  profile_edit: 'profile_edit',
  edit_profile_name: 'profile_name',
  edit_profile_image: 'profile_image',
  add_user: 'add_user',
  add_sub_profile: 'add_children_profile',
  add_sub_profile_info: 'add_children_profile_info',
  search: 'search',
  settings: 'settings',
  consent: 'consent',
  consent_edit: 'consent_edit',
  tos: 'tos_changed',
  favorites: 'favorites',
  onboarding: 'onboarding_login',
};

/**
 * Always send parent ID when user is subaccount
 * @param user
 * @returns {undefined | string}
 */
export const getUserIdForYleSk = (user: LoggedInUser | undefined | null) => {
  if (!user) return undefined;
  return user.isSubAccount && user.parentId ? user.parentId : user.userId;
};

export function getUtmParameters(
  mode: Mode,
  isPlayer: boolean,
  id: string
): UtmParameters {
  return {
    utm_source: mode === tizenMode ? 'samsung' : mode,
    utm_campaign: encodeURIComponent(id),
    utm_content: encodeURIComponent(id).concat(
      '-',
      isPlayer ? 'startover' : 'preview'
    ),
    utm_medium: 'external-tv',
  };
}
